import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PRODUCT_SUBCATEGORY_ROUTE } from '../shared/constants/routes';
import { AuthGuard } from '../guards/auth.guard';
import { ProductSubcategoryComponent } from './product-subcategory/product-subcategory.component';

const routes: Routes = [
  {
    path: `${PRODUCT_SUBCATEGORY_ROUTE}/:product_category_id`,
    component: ProductSubcategoryComponent,
    canActivate: [AuthGuard],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ProductSubcategoryRoutingModule {}
